// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"TrustedBySection_cardContainer__MTGPt","cardBox":"TrustedBySection_cardBox__cHxWD"};